import styled from 'styled-components';
import { PropsWithChildren } from 'react';
import { colors } from '@zopauk/react-components';
import { Card as CardType } from '@/utils/models/cards';

const Label = styled.label`
  color: ${colors.greyDark};
  display: block;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 4px;
  font-weight: 400;
`;

type ProductLabelProps = {
  card?: CardType;
};

export const ProductLabel = ({ card }: ProductLabelProps) => {
  const cardProductLabel = card?.shortTitle === 'Savings' ? 'Fixed Term Savings' : 'Zopa Product';

  return card ? <Label>{card.productLabel ? card.productLabel : cardProductLabel}</Label> : null;
};

export const ProductLabelV2 = ({ children }: PropsWithChildren) => <Label>{children}</Label>;
